var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("compare-sect-new", { attrs: { background: "background-img" } }),
      _vm._v(" "),
      _c("compare-sect-new", { attrs: { background: "background-grey" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }